import { appendVueRoute, Role } from '@therame/shared';
import { type RouteRecordRaw } from 'vue-router';

const shopRoutes: Array<RouteRecordRaw> = [
  {
    ...appendVueRoute<'patientShop'>('patientShop', '/shop'),
    component: () => import('/src/views/PatientShop.vue'),
    meta: {
      layout: 'default',
      title: 'Praxisshop',
      requiresAuth: true,
      requiresOnboarding: true,
      noPadding: true,
      accessPossibleWithRoles: [Role.PATIENT],
    },
  },
];

export default shopRoutes;
